// extracted by mini-css-extract-plugin
export var desktopCardLayout = "_redotech-redo-customer-portal-app-lib-portal-four-shared-components-edit-address-modal-desktop-card-layout";